<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.71,4.29C8.53,4.11,8.28,4,8,4C7.45,4,7,4.45,7,5C7,5.28,7.11,5.53,7.29,5.71C7.29,5.71,8.59,7,8.59,7C8.59,7,5,7,5,7C4.45,7,4,7.45,4,8C4,8.55,4.45,9,5,9C5,9,8.59,9,8.59,9C8.59,9,7.3,10.29,7.3,10.29C7.11,10.47,7,10.72,7,11C7,11.55,7.45,12,8,12C8.28,12,8.53,11.89,8.71,11.71C8.71,11.71,11.71,8.71,11.71,8.71C11.89,8.53,12,8.28,12,8C12,7.72,11.89,7.47,11.71,7.29C11.71,7.29,8.71,4.29,8.71,4.29C8.71,4.29,8.71,4.29,8.71,4.29ZM8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0ZM8,14C4.69,14,2,11.31,2,8C2,4.69,4.69,2,8,2C11.31,2,14,4.69,14,8C14,11.31,11.31,14,8,14C8,14,8,14,8,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CircleArrowRight',
} as DefineComponent
</script>
